// app.reducer.ts
import { ActionReducerMap } from '@ngrx/store';
import { AppState } from './appState.state';
import { userReducer } from './userStore/user.reducer';

// Note: tokensStore folder not found; token slice removed for now to avoid runtime resolution errors.
export const appReducers: ActionReducerMap<AppState> = {
  user: userReducer
};
